import { fileExtension, fileTypeIdentity, fileTypeLabel, formatFileSize, formatUploadedDate, previewKindFor, uploadedSortValue } from '@features/Attachments/utils/fileFormatting';
import { reportOptionKeys, reportOptionsSortKey, reportOptionsSummary } from './reportOptions';
import { RESULT_NONE } from '../constants';
/** Display text for a result value. `null` is "None" — the enum has no member for it. */
export function resultLabel(answer, translateFn) {
    if (!answer)
        return translateFn('result.none');
    return translateFn(`result.${answer}`);
}
/** Enriches one API row with every display/filter/sort value the surface and columns need. */
export function toInspectionAttachmentRow(api, translateFn) {
    var _a, _b, _c, _d, _e;
    const sizeBytes = (_a = api.fileSize) !== null && _a !== void 0 ? _a : 0;
    // Type, preview kind and extension come from the REAL filename, never from `name`. `name` is a
    // user-editable label and usually has no extension — deriving from it makes every row render
    // Type "File" and breaks the type filter, the type sort and the preview. Falls back to `name`
    // only when a legacy row has no stored filename.
    const typeSource = ((_b = api.fileName) === null || _b === void 0 ? void 0 : _b.trim()) ? api.fileName : api.name;
    const showOnReport = Boolean(api.showOnReport);
    const includeInCoverLetter = Boolean(api.includeInCoverLetter);
    return {
        id: api.id,
        name: api.name,
        createdAt: api.createdAt,
        uploadedLabel: formatUploadedDate(api.createdAt),
        uploadedSortValue: uploadedSortValue(api.createdAt),
        sizeBytes,
        sizeLabel: formatFileSize(sizeBytes),
        answer: api.answer,
        resultFilterValue: (_c = api.answer) !== null && _c !== void 0 ? _c : RESULT_NONE,
        resultLabel: resultLabel(api.answer, translateFn),
        // Normalised to '' so the inline text cells never render "null" and an empty edit round-trips
        // as a cleared field rather than the string "null".
        technicianName: (_d = api.technicianName) !== null && _d !== void 0 ? _d : '',
        certificationNumber: (_e = api.certificationNumber) !== null && _e !== void 0 ? _e : '',
        showOnReport,
        includeInCoverLetter,
        reportOptionKeys: reportOptionKeys(showOnReport, includeInCoverLetter),
        reportOptionsSummary: reportOptionsSummary(showOnReport, includeInCoverLetter, translateFn),
        reportOptionsSortKey: reportOptionsSortKey(showOnReport, includeInCoverLetter),
        typeLabel: fileTypeLabel(typeSource, translateFn),
        typeFilterValue: fileTypeIdentity(typeSource),
        previewKind: previewKindFor(typeSource),
        extension: fileExtension(typeSource),
        url: api.url
    };
}
